export default "https://npm-assets.fiverrcdn.com/assets/@fiverr/search_perseus/apps/Graphic_Design_de-DE.79e8163.vtt";